import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { AxisBottom } from '@vx/axis';

import { colors } from '../../styles';

export interface Props {
  className?: string;
  hideEnds?: boolean;
  left?: number;
  padding?: number;
  scale?: any;
  stroke?: string;
  tickStroke?: string;
  top?: number;
}

const tickLabelProps = () => ({
  textAnchor: 'middle',
  fontFamily: 'Arial',
  fontSize: 10,
  fill: colors.grey600,
});

class AxisBottomWrapper extends React.Component<Props, any> {
  static defaultProps: Props = {
    hideEnds: false,
    left: 0,
    padding: 0,
    stroke: colors.grey500,
    tickStroke: colors.grey500,
    top: 0,
  };

  public render() {
    const {
      className,
      hideEnds,
      padding,
      top,
      scale,
      stroke,
      tickStroke,
    } = this.props;
    const otherClasses = hideEnds ? 'hide-ends' : '';

    return (
      <g className={`${otherClasses} ${className}`} data-testid="axis-bottom">
        <AxisBottom
          {...{ scale, stroke, tickStroke }}
          hideTicks={true}
          tickLength={0}
          top={top + padding}
          tickTransform={`translate(0, ${padding})`}
          tickLabelProps={tickLabelProps}
        />
      </g>
    );
  }
}

const StyledAxisBottomWrapper = styled(AxisBottomWrapper)`
  &.hide-ends .vx-axis-tick {
    :first-of-type,
    :last-of-type {
      display: none;
    }
  }
`;

export default StyledAxisBottomWrapper;
